module.exports = __webpack_public_path__ + "media/images/well-thumbs-up-de0e4673cd61d7c124baef9d86954fae.png";